export default [
  {
    path: "/grouprob",
    component: () => import("@/pages/groupRob"),
    children: [
      {
        path: "",
        redirect: "a",
      },
      {
        path: "a",
        component: () => import("@/pages/groupRob/a-list"),
      },
      {
        path: "b",
        redirect: "b/0",
      },
      {
        path: "b/:status",
        component: () => import("@/pages/groupRob/b-list"),
      },
    ],
    meta: {
      title: "商品列表",
    },
  },
  {
    path: "/grouprob/order/:ordersn",
    component: () => import("@/pages/groupRob/order"),
    meta: {
      title: "订单详情",
    },
  },
  {
    path: "/grouprob/share",
    component: () => import("@/pages/groupRob/share"),
    meta: {
      title: "商品详情",
    },
  },
  {
    path: "/grouprob/mine",
    component: () => import("@/pages/groupRob/mine"),
    meta: {
      title: "抢购我的",
    },
  },
  {
    path: "/grouprob/panicDetail",
    component: () => import("@/pages/groupRob/panic-detail"),
    meta: {
      title: "明细详情",
    },
  },
  {
    path: "/grouprob/panicWithdraw",
    component: () => import("@/pages/groupRob/panic-withdraw"),
    meta: {
      title: "明细详情",
    },
  },
];
